import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import styled from 'styled-components';
import { CONTACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { CRM_OBJECT_TAG } from 'customer-data-objects/property/ExternalOptionTypes';
import { getReferenceTypeFromProperty } from 'reference-resolvers-lite/utils/getReferenceTypeFromProperty';
import { normalizePropertyDefinition } from '../../utils/normalizePropertyDefinition';
const StyledRow = styled.div.withConfig({
  displayName: "InternalValueTooltip__StyledRow",
  componentId: "luiuxn-0"
})(["display:flex;align-items:center;"]);
// properties that don't need to be filtered by their internal value and should
// NOT display the internal value tooltip, this is a property shared by all
// objects so it does not need an objectTypeId
const DISPLAY_VALUE_NO_TOOLTIP = new Set(['hubspot_team_id']); // properties that don't need to be filtered by their internal value but should still display the internal value tooltip (with different content)

const DISPLAY_VALUE_FILTERABLE_BY_OBJECT_TYPE_ID = {
  [CONTACT_TYPE_ID]: {
    salesforcecampaignids: true
  }
};
const REFERENCE_TYPES_NO_TOOLTIP = new Set([CRM_OBJECT_TAG]);

const InternalValueTooltip = ({
  children,
  internalValue,
  objectTypeId,
  property
}) => {
  // there is no point displaying an internal value tooltip when the internal
  // value is empty. an empty property input will be shown as a placeholder ('--')
  if (!internalValue) {
    return children;
  }

  const referenceType = getReferenceTypeFromProperty(normalizePropertyDefinition(property), objectTypeId);

  if (DISPLAY_VALUE_NO_TOOLTIP.has(property.name) || referenceType && REFERENCE_TYPES_NO_TOOLTIP.has(referenceType)) {
    return children;
  }

  const filterablePropertiesByName = DISPLAY_VALUE_FILTERABLE_BY_OBJECT_TYPE_ID[objectTypeId];
  const readOnlyTooltipMessage = filterablePropertiesByName && filterablePropertiesByName[property.name] ? 'customerDataProperties.PropertyInputExternalOption.internalValueTooltip' : 'customerDataProperties.PropertyInputExternalOption.internalValueRequiredForFiltersTooltip';
  return /*#__PURE__*/_jsxs(StyledRow, {
    children: [/*#__PURE__*/_jsx(UIHelpIcon, {
      tooltipPlacement: "top right",
      className: "m-right-1",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: readOnlyTooltipMessage,
        options: {
          internalValue
        }
      })
    }), children]
  });
};

export default InternalValueTooltip;